module.exports = __webpack_public_path__ + "static/media/ClosedHH808.7d30054f.wav";